module.exports = __webpack_public_path__ + "img/4.0407a6b1.png";